import React, { useContext, useState } from "react";
import { LocationContext } from "./context";

const LocationList = () => {
  const { loading, locations, activeLocation, updateActiveLocation } =
    useContext(LocationContext);

  const [searchQuery, setSearchQuery] = useState("");

  if (loading || !locations) {
    return <div className="gp-location-list-loading">Loading...</div>;
  }

  const filteredLocations = locations.filter((location) =>
    location.location_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="gp-location-list">
      <div className="gp-location-list-search">
        <input
          type="search"
          placeholder="Search locations"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <hr />
      <ul className="gp-location-list-items">
        {filteredLocations.map((location, index) => (
          <li
            key={`location-${index}`}
            className={`${
              activeLocation?.location_name === location.location_name
                ? "active-location"
                : ""
            }`}
            onClick={() =>
              !activeLocation || activeLocation !== location
                ? updateActiveLocation(location)
                : updateActiveLocation(null)
            }
          >
            {location.location_name}
          </li>
        ))}
        {/* Display a message if no locations match the search */}
        {filteredLocations.length === 0 && (
          <li className="gp-location-list-no-results">No locations found.</li>
        )}
      </ul>
    </div>
  );
};

export default LocationList;
